export const linkRef: string = '?ref=Michael.Minor';

export default linkRef;
